module.exports = __webpack_public_path__ + "static/fonts/Metropolis-Bold.89e3b28.woff";


//////////////////
// WEBPACK FOOTER
// ./src/assets/fonts/metropolis/Metropolis-Bold.woff
// module id = rePL
// module chunks = 1